import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextInput from "../../../shared/components/ui/CustomTextInput";
import AppButton from "../../../shared/components/ui/AppButton";
import {
  Wrapper,
  Container,
  LogoContainer,
  RoleTypeDisplay,
  Notice,
  ConstructionNotice,
  StyledForgotPassword,
  ErrorMessageDisplay,
  BottomLinks,
  LoginSwitchLink
} from "../styles/Login.styles";
import { useLogin } from "../hooks/useLogin";
import ForgotPasswordLink from "./ForgotPasswordLink";
import { ICONS, LOGOS } from "../../../assets";

const Login = () => {
    const {
        email,
        password,
        errors,
        setEmail,
        setPassword,
        handleSubmit,
        registerStudent,
        registerTutor,
        isLoginLoading,
        errorMessage,
    } = useLogin();
    const location = useLocation();
    const navigate = useNavigate();
    
    // Extract userRole from pathname (/login/student or /login/tutor)
    const userRole = location.pathname.split('/')[2]; // Gets 'student' or 'tutor'

    const isTutorRole = userRole === "tutor";
    const isStudentRole = userRole === "student";

    const handleLogoClick = () => {
        navigate('/');
    };

    const switchToStudentLogin = () => {
        navigate('/login/student');
    };

    const switchToTutorLogin = () => {
        navigate('/login/tutor');
    };

    return (
        <Wrapper>
            <Container>
                <LogoContainer>
                    <div>
                        <img 
                            src={LOGOS.main} 
                            alt="Logo" 
                            className="logo" 
                            onClick={handleLogoClick}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                    {/**
                    {isTutorRole && (
                        <Notice>
                            If you are eager to learn and schedule a class as a STUDENT,
                            we like your excitement and it is about to launch in couple of days.
                        </Notice>
                    )}
                    {isStudentRole && (
                         <ConstructionNotice>
                            <div>
                                <p>
                                    We're busy giving the student login page a glow-up — think of it like a brainy makeover.
                                    <br />
                                    A few more clicks, a dash of code, and some virtual elbow grease...
                                    and it'll be ready for you to book your first class in no time!
                                </p>
                                <p>
                                    Thanks for your patience while we chase bugs, tame tech gremlins, and add extra sparkle ✨.
                                    <br />
                                    Check back soon — your learning adventure is just around the corner!
                                </p>
                                <p style={{ marginTop: '20px', fontStyle: 'italic' }}>
                                    – The Illuminate Team
                                </p>
                            </div>
                        </ConstructionNotice>
                    )}

                    */}
                </LogoContainer>

                <RoleTypeDisplay>
                    {userRole} Login
                </RoleTypeDisplay>

                <>
                    <CustomTextInput
                        leftIcon={ICONS.email}
                        color="black"
                        backgroundColor="white"
                        value={email}
                        placeholder="Email"
                        onChangeText={setEmail}
                        error={errors.email?.[0]}
                    />

                    <CustomTextInput
                        secureTextEntry
                        color="black"
                        backgroundColor="white"
                        leftIcon={ICONS.password}
                        value={password}
                        placeholder="Password"
                        onChangeText={setPassword}
                        error={errors.password?.[0]}
                    />
                    <StyledForgotPassword style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <ForgotPasswordLink />
                        {isTutorRole && (
                            <LoginSwitchLink onClick={switchToStudentLogin}>
                                Login as Student
                            </LoginSwitchLink>
                        )}
                        {isStudentRole && (
                            <LoginSwitchLink onClick={switchToTutorLogin}>
                                Login as Tutor
                            </LoginSwitchLink>
                        )}
                    </StyledForgotPassword>
                    <AppButton
                        onClick={() => handleSubmit(userRole!)}
                        title={isLoginLoading ? "Logging in..." : "Login"}
                        disabled={isLoginLoading}
                        style={{ width: '100%' }}
                    />
                </>

                {errorMessage && <ErrorMessageDisplay>{errorMessage}</ErrorMessageDisplay>}

                <BottomLinks>
                    <p onClick={registerStudent}>
                        New to Illuminate? <span>Enroll Here</span>
                    </p>
                    <p onClick={registerTutor}>
                        Want to teach on Illuminate? <span>Enroll Here</span>
                    </p>
                </BottomLinks>
            </Container>
        </Wrapper>
    );
};

export default Login;
